import React, { useCallback, useContext } from 'react'
import { Table } from 'components'
import { SchoolContext } from './SchoolContext'
import { schoolHooks, SchoolClassesForGrade } from '.'
import { dataGridModel } from 'keys'
import { isEmpty } from 'lodash'

const Affiliations = () => {
    const { schoolClassGrades, schoolClassGradesOptions, gradeOpen, setGradeOpen, rowOpen, setRowOpen, page, setPage, pageSize, setPageSize, searchVal, setSearchVal, sorting, setSorting, setClassIndexTab, promoteSelection, setPromoteSelection, promoteSelectedGradeId, setPromoteSelectedGradeId } = useContext(SchoolContext)
    const gradesColumns = schoolHooks.useGradesTableColumns()

    const currentGrade = schoolClassGrades?.data?.find(item => item.id == gradeOpen) || []

    const updateGrade = useCallback(() => {
        setClassIndexTab(0)
    }, [])

    // בחירה (בשביל העלאת שנה ) מוגבלת לשכבה אחת בכל פעם
    const onPromoteSelectionChange = useCallback((next) => {
        setPromoteSelection(next)
        if (isEmpty(next)) {
            setPromoteSelectedGradeId(null)
            return
        }
        if (!promoteSelectedGradeId) {
            const grade = schoolClassGrades?.data?.find(g =>
                next[g.id] || g.classes?.some(c => next[c.id])
            )
            if (grade) setPromoteSelectedGradeId(grade.id)
        }
    }, [promoteSelectedGradeId, schoolClassGrades])

    const canSelectGradeRow = useCallback((row) =>
        !promoteSelectedGradeId || row.original.id == promoteSelectedGradeId
        , [promoteSelectedGradeId])

    return (
        <div className='grades'>
            <Table
                withTitle
                loading={schoolClassGrades.isFetching}
                data={{ results: schoolClassGrades.data || [] }}
                columns={gradesColumns}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                rowOpen={gradeOpen}
                setRowOpen={setGradeOpen}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                sorting={sorting}
                setSorting={setSorting}
                hideSorting
                hidePagination
                hideToolbar
                queryKey={schoolClassGradesOptions.queryKey}
                visibilityModelKey={dataGridModel.school_classes}
                selectedRowIds={promoteSelection}
                setSelectedRowIds={onPromoteSelectionChange}
                onRowSelection={onPromoteSelectionChange}
                canSelectRow={canSelectGradeRow}
                collapse={{
                    show: true,
                    columns: gradesColumns,
                    showToolbar: false,
                    onCollapse: updateGrade,
                    component: () =>
                        <SchoolClassesForGrade
                            grade={currentGrade}
                            row={currentGrade?.classes} />,
                    data: [],
                    showChollapseIcon: true,
                    hideVisibilityColumns: true,
                }}
            />
        </div>
    )
}

export default Affiliations